import { render, staticRenderFns } from "./UserProvinceLoginPage.vue?vue&type=template&id=d96961ac&scoped=true"
import script from "./UserProvinceLoginPage.vue?vue&type=script&lang=js"
export * from "./UserProvinceLoginPage.vue?vue&type=script&lang=js"
import style0 from "./UserProvinceLoginPage.vue?vue&type=style&index=0&id=d96961ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96961ac",
  null
  
)

export default component.exports